import useFetch from 'hook/UseFetch';
import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { LaboratoryService } from 'services/LaboratoryService';

const LaboratoryContext = createContext({});

// noinspection JSValidateTypes
/**
 * Return object containing Laboratory information apart from the name already available in the url
 * @returns {LaboratoryInfo}
 */
export const useLaboratoryInfo = () => useContext(LaboratoryContext);

export const LaboratoryInfoProvider = ({ children }) => {
  const { laboratory } = useParams();
  const laboratoryGlobalStats = useFetch(() => LaboratoryService.getLaboratoryInfo(laboratory), {}).response;
  return (
    <LaboratoryContext.Provider
      value={laboratoryGlobalStats}
    >
      {children}
    </LaboratoryContext.Provider>
  );
};